import { formatDate } from '@fullcalendar/core'

const classDates = [
	'01-13',
	'01-15',
	'01-18',
	'01-20',
	'01-22',
	'01-25',
	'01-27',
	'01-29',
	'02-01',
	'02-03',
	'02-08',
	'02-10',
	'02-15',
	'02-19',
	'02-22',
	'02-24',
	'02-26',
	'03-01',
	'03-03',
	'03-05',
	'03-08',
	'03-12',
	'03-15',
	'03-17',
	'03-19',
	'03-24',
	'03-26',
	'03-29',
	'03-31',
	'04-02',
	'04-05',
	'04-07',
	'04-09',
	'04-12',
	'04-14',
	'04-16',
	'04-19',
	'04-21',
	'04-26',
	'04-28',
	'04-30'
].map(x=>'2021-'+x);

const examPeriod = [
	'05-05',
	'05-06',
	'05-07',
	'05-10',
	'05-11'
].map(x=>'2021-'+x);

const breakDays = [
	'02-12',
	'02-17',
	'02-18',
	'03-09',
	'03-10',
	'03-22',
	'03-25',
	'04-23'
].map(x=>'2021-'+x);

const problemSetsAssigned = [
	'03-01',
	'04-28'
].map(x=>'2021-'+x);

const problemSetsDue = [
	'03-08',
	'05-05'
].map(x=>'2021-'+x+'T09:10');

const dialoguesDue = [
	'02-22',
	'03-31',
	'04-26'
].map(x=>'2021-'+x+'T09:10');

const classesCancelled = [
	'02-05'
].map(x=>'2021-'+x);

const linkto = (x,y) => `<a href="${y}"><i>${x}</i></a>`

const modules = [
	{title: "Introduction", 
	readings: [	
		[], 
		[]
		]
	},
	{title: "Dualism", 
	extendedtitle: "The Mind/Body Problem I", 
	readings: [
		[	`Ibn Sina (Avicenna), selections on ${linkto(`The Floating Man`,"https://www.davidsanson.com/texts/avicenna-floating-man.html")}`, 
			`René Descartes, ${linkto("Meditations on First Philosophy", "/assets/Descartes.pdf")}, selections from 2<sup>nd</sup> and 6<sup>th</sup> Meditations`],
		[	`Suzanne Cunningham, pages 1-11`, `Rocco Gennaro, sections 1.1 and 1.2`],
		[	`Rocco Gennaro, sections 1.3 and 1.4`],
		[	`Rocco Gennaro, sections 2.1, 2.2, and 2.3`, `Jen McWeeny, ${linkto("Princess Elisabeth and the Mind-Body Problem","assets/McWeenyPEMBP.pdf")}`],
		[ 	`Smith and Jones, ${linkto("Difficulties for the Dualist, sections 6-8", "/assets/SmithJonesDFTD.pdf")}`]
		]
	},
	{title: "Physicalism", 
	extendedtitle: "The Mind/Body Problem II", 
	readings: [
		[`J. J. C. Smart, ${linkto("Sensations and Brain Processes","/assets/SmartSBP.pdf")}`], 
		[`Suzanne Cunningham, pages 21-31 and 33-36`, `Rocco Gennaro, section 2.4`],
		[`Gilbert Ryle, selections from ${linkto("The Concept of Mind","/assets/RyleCM.pdf")}`, `Suzanne Cunningham, pages 14-20`],
		[`Daniel Dennett, ${linkto("Intentional Systems Theory","https://ase.tufts.edu/cogstud/dennett/papers/intentionalsystems.pdf")} (sections 1 and 2 are assigned; read sections 3 and 4 if interested)`],
		[`Suzanne Cunningham, pages 38-41, 45-48 (skip section called "Machine Functionalism")`, `Philip Quinlan and Ben Dyson, ${linkto("reading on Marr's levels of explanation", "assets/QuinlanDyson.pdf")}`],
		[`Larissa MacFarquahar, ${linkto("Two Heads","https://www.newyorker.com/magazine/2007/02/12/two-heads")} (${linkto("alternate link", "https://web.ics.purdue.edu/~drkelly/NewYorkerChurchlands2007.pdf")})`], 
		]
	},
	{title: "Consciousness", 
	readings: [
		[`Suzanne Cunningham, pages 54-69`, `<i>Optional</i> : Susan Blackmore, ${linkto("What Is It Like...", "/assets/BlackmoreWIIL.pdf")}`],
		[`Rocco Gennaro, section 2.5`],			// Mary the Color Scientist
		[`John Perry, ${linkto("Dialogue on Consciousness, Wednesday","/assets/PerryDCW.pdf")}`, `<i>Optional</i> : Amy Kind, ${linkto("Chalmers' Zombie Argument", "/assets/KindCZA.pdf")}`], // Zombies
		[`Sydney Shoemaker, ${linkto("The Inverted Spectrum","http://jraissati.com/PHIL201/Shoemaker_1982_TheInvertedSpectrum.pdf")}, sections 1-3`], // Inverted Spectrum
		[`Suzanne Cunningham, pages 69-79`],
		[`Suzanne Cunningham, pages 79-93`], // Maybe do Ryle's breakdown of meanings of "conscious" somewhere
		[`Raymond Smullyan, ${linkto("An Epistemological Nightmare", "https://www.mit.edu/people/dpolicar/writing/prose/text/epistemologicalNightmare.html")}`],
		[`Daniel Dennett, ${linkto("Quining Qualia", "https://ase.tufts.edu/cogstud/dennett/papers/quinqual.htm")}`, `<i>Optional</i>: Daniel Dennett, ${linkto("Consciousness Explained", "/assets/DennettCEch12.pdf")}, chapter 12`]
		]
	},
	{title: "Animal Minds", 
	readings: [
		[`Rocco Gennaro, sections 3.1, 3.2, and 3.3`],
		[`Suzanne Cunningham, pages 131-156`],
		[`Oxford Companion to Consciousness, ${linkto("entries on 'animal consciousness', 'animal consciousness: dolphins', and 'animal consciousness: great apes'", "/assets/OCC.pdf")}`],
		//[`Amy Kind, ${linkto(`Nagel's "What Is It Like To Be a Bat" Argument against physicalism`,"/assets/KindNWIIL.pdf")}`, `<i>Optional</i> : Thomas Nagel, ${linkto("What Is It Like to Be a Bat?", "https://warwick.ac.uk/fac/cross_fac/iatl/study/ugmodules/humananimalstudies/lectures/32/nagel_bat.pdf")}`],  // should have a better animal here.  octopus?
		[`Sarah Blaffer Hrdy, ${linkto("Mothers and Others", "/assets/HrdyMOch2.pdf")}, pages 33-51`, `<i>Optional</i>: Sarah Blaffer Hrdy, Mothers and Others, the rest of chapter 2`],
		[`Peter Godfrey-Smith, ${linkto("The Mind of an Octopus", "https://www.scientificamerican.com/article/the-mind-of-an-octopus/")}`, `Michael Graziano, ${linkto("The Octopus: An Alien Among Us", "https://lithub.com/the-octopus-an-alien-among-us/")}`]
		]
	},
	{title: "Computer Minds", 
	readings: [
		[`Suzanne Cunningham, pages 189-198`],  //Turing test, GOFAI
		[`Suzanne Cunningham, pages 41-45`, `Ian Ravenscroft, ${linkto("The Computational Theory of Mind", "/assets/RavenscroftCTM.pdf")}`], // Turing Machine, Syntax/Semantics
		[`Suzanne Cunningham, pages 199-212`],
		[`Suzanne Cunningham, pages 212-220`, `Play around with ${linkto("AI Dungeon", "https://play.aidungeon.io/main/landing")}`],
		[`Stephen Pinker, ${linkto("How the Mind Works","")}, pages 98-131`],
		[`Suzanne Cunningham, pages 198-199`,`<i>Optional</i> : John Searle, ${linkto("Can Computers Think?", "assets/SearleCCT.pdf")}`, `<i>Optional</i> : The Mind Project, ${linkto("The Robot Reply", "https://mind.ilstu.edu/curriculum/searle_chinese_room/searle_robot_reply.html")}`, `<i>Optional</i> : you can finish the remaining sections of Rocco Gennaro, if you'd like`]
		]
	},
	{title: "Emotions", 
	readings: [
		[`Suzanne Cunningham, pages 96-105`, `<i>Optional</i> : Richard Dub, ${linkto("Emotions", "assets/DubE.pdf")}`],
		[`Suzanne Cunningham, pages 106-112`],
		[`Suzanne Cunningham, pages 112-120`],
		[`Suzanne Cunningham, pages 120-128`]
		]
	},
	{title: "The Self", 
	readings: [
		[`Suzanne Cunningham, pages 159-170`],
		[`Suzanne Cunningham, pages 170-186`],
		[`Todd Feinberg, ${linkto("Altered Egos", "/assets/FeinbergAEChap2.pdf")}, chapter 2`],
		[`Todd Feinberg, ${linkto("Altered Egos", "/assets/FeinbergAEChap7.pdf")}, chapter 7`],
		[]
		]
	}
];


const buildModuleDates = () => {
	let currClass = 0;
	const moduleDates = [];
	for (let i=0; i<modules.length; i++) {
		for (let j=0; j<modules[i].readings.length; j++) {
			moduleDates.push({
				title: modules[i].title,
				start: classDates[currClass],
				readings: modules[i].readings[j],
				modulelength: modules[i].readings.length,
				firstinmodule: !j
			})
			currClass++;
		}
	}
	return moduleDates;
}


const moduleEvents = buildModuleDates();
const dialogueEvents = dialoguesDue.map((x,i)=>({title: `Dialogue ${i+1} due`, start: x	}))
const problemSetsAssignedEvents = problemSetsAssigned.map((x,i)=>({title:`Assignment ${i+1} Available`, start: x}))
const problemSetsDueEvents = problemSetsDue.map((x,i)=>({title:`Assignment ${i+1} Due`, start: x}))
const breakDayEvents = breakDays.map((x,i)=>({title:"Break Day", start: x}));
const examEvents = examPeriod.map((x,i)=>({title:"Exams", start: x}));
const cancelledEvents = classesCancelled.map((x,i)=>({title:"Class cancelled", start: x}));

export { classDates, moduleEvents, breakDayEvents, problemSetsAssignedEvents, problemSetsDueEvents, dialogueEvents, examEvents, cancelledEvents };